export const ADD_GRID = 'ADD_GRID'
export const NO_DAYS = 'NO_DAYS'
export const RESET = 'RESET'
export const SET_MATRIX = 'SET_MATRIX'
